import Vue from 'vue'
import Router from 'vue-router'
import product from './product'
import chart from './chart'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path:'/',
      redirect:'/studio'
    },
    {
      path:'/chart',
      component:resolve=>{
        require(['../view/product/base.vue'],resolve)
      },
      children:chart,
      meta:{
        title:''
      }
    },{
      path: '/zwds',
      name: 'zwds',
      component: resolve => {
        require(['../view/zwds.vue'], resolve)
      },
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/zwds_from',
      name: 'zwds_from',
      component: resolve => {
        require(['../view/zwds_from.vue'], resolve)
      }
    },
    {
      path: '/xuezhang',
      name: 'xuezhang',
      component: resolve => {
        require(['../view/xuezhang.vue'], resolve)
      }
    },
    {
      path: '/luckDraw',
      name: 'luckDraw',
      component: resolve => {
        require(['../view/luckDraw.vue'], resolve)
      }
    },
    {
      path: '/articles_detail',
      name: 'articles_detail',
      component: resolve => {
        require(['../view/articles_detail.vue'], resolve)
      }
    },
    { // 诊股首页
      path: '/diagnostic',
      name: 'diagnostic-stock',
      component: resolve => {
        require(['../view/diagnosticStock/index.vue'], resolve)
      }
    },
    { // 诊股诊断
      path: '/diagnostic_graph',
      name: 'diagnostic-stock-graph',
      component: resolve => {
        require(['../view/diagnosticStock/graph.vue'], resolve)
      }
    },
    { // 问股首页
      path: '/askStock',
      name: 'askStock',
      component: resolve => {
        require(['../view/askStock/index.vue'], resolve)
      }
    },
    { // 问股诊断
      path: '/askStockGraph',
      name: 'askStockGraph',
      component: resolve => {
        require(['../view/askStock/graph.vue'], resolve)
      }
    },

    //经济报告
    {
      path: '/emconomics',
      name: 'emconomics',
      component: resolve => {
        require(['../view/emconomics/emconomics.vue'], resolve)
      }
    },
    //经济报告2
    {
      path: '/emconomics2',
      name: 'emconomics2',
      component: resolve => {
        require(['../view/emconomics/emconomics2.vue'], resolve)
      },
      meta:{
        title:'中国经济报告·2019年基金业变革与展望-巨丰财经&网易财经大型经济论坛，李扬、张燕生、邬传雁、沈梁军、周应波、王超、胡昕炜、汪晟等国内知名经济学家和顶级智囊受邀参会。',
        description: '2019年1月25日，由巨丰财经、清泉研究院主办、网易财经和清华大学金砖国家与全球治理智库（CBGG）协办的大型经济论坛——“中国经济报告·2019年基金业变革与展望”将在北京钓鱼台国宾馆举行。李扬、张燕生、邬传雁、沈梁军等数十名经济学家和顶级智囊将出席会议，共同探讨2019宏观经济走势以及基金业的发展，挖掘新的投资机会，在巨变的环境下实现基金业的进一步发展。',
        keywords: '巨丰投顾，中国经济报告，网易研究局，巨丰财经，钓鱼台，研讨会，星石投资，泓德基金，深交所，陈志武，余永定，姚洋，李扬、张燕生、邬传雁、沈梁军、周应波、王超、胡昕炜、汪晟，刘元春，李稻葵，赵锡军，刘姝威，魏建国，厉以宁，尹中卿，贺铿，李铁，张春，迟福林，魏杰，郑永年，陈耀，王忠民，田国强，贾康，宋晓梧，季晓南，邱晓华，李迅雷，李毅中，许小年'
      }
    },
    //经济报告3
    {
      path: '/emconomics-report20190220',
      name: 'emconomics3',
      component: resolve => {
        require(['../view/emconomics/emconomics3.vue'], resolve)
      },
      meta:{
        title:'中国经济报告·科创板的创新与发展-巨丰财经&网易财经大型经济论坛，吴晓求、贺强、姚余栋、滕泰、水皮、姚长盛、俞志晨、付英波、徐明等国内知名经济学家和顶级智囊受邀参会。',
        description: '2019年2月20日，由巨丰财经、清泉研究院主办、网易财经和清华大学金砖国家与全球治理智库（CBGG）协办的大型经济论坛——“中国经济报告·科创板的创新与发展”将在北京钓鱼台国宾馆举行。吴晓求、贺强、姚余栋、滕泰、水皮、姚长盛、俞志晨、付英波、徐明等数十名经济学家和顶级智囊将出席会议，共同探讨科创板的创新与发展，围绕科创板如何打好“创新牌”，深入剖析科创板的相关问题及焦点难点，帮助机构、企业和投资者把握科创板机遇以及未来的投资机会。',
        keywords: '巨丰投顾，中国经济报告，网易研究局，巨丰财经，钓鱼台，研讨会，科创板，创新牌，上海证券交易所，证监会，中国人民大学，中央财经大学，大成基金，万博新经济研究院，旷视科技，云从科技，吴晓求、贺强、姚余栋、滕泰、水皮、姚长盛、俞志晨、付英波、徐明'
      }
    },
    //经济报告3
    {
      path: '/emconomics-report20190530',
      name: 'emconomics4',
      component: resolve => {
        require(['../view/emconomics/emconomics4.vue'], resolve)
      },
      meta:{
        title:'中国经济报告-网易研究局&巨丰财经钓鱼台大型经济论坛，倪光南、方滨兴、王建宙、田溯宁、李丰、岳斌、武超则、项立刚、郭一鸣等国内知名经济学家和顶级智囊受邀参会。',
        description: '2019年5月30日，由巨丰财经、清泉研究院、网易财经、金砖智库CBGG联合主办的大型经济论坛——“中国经济报告·5G：未来已来”将在北京钓鱼台国宾馆举行。届时，中国工程院院士倪光南、中国工程院院士方滨兴、前中国移动董事长王建宙、宽带资本董事长田溯宁、峰瑞资本创始合伙人李丰、高榕资本创始合伙人岳斌、中信建投研究所所长武超则、中国通信业知名观察家项立刚、巨丰投顾首席投资顾问郭一鸣等数十位知名专家学者、市场分析师、企业代表拟出席本次经济峰会，深入探讨5G时代的发展与未来，挖掘新的投资机会。',
        keywords: '巨丰投顾，中国经济报告，网易研究局，巨丰财经，钓鱼台，经济论坛，圆桌会议，中国工程院，倪光南，方滨兴，中国移动，王建宙，宽带资本，田溯宁，峰瑞资本，李丰，高榕资本，岳斌，中信建投，武超则、中国通信，项立刚，巨丰投顾，郭一鸣，华为，姚长盛，天风证券，唐海清，李迪。'
      }
    },
    //5g报告专栏
    {
      path: '/emconomics-report20190801',
      name: 'emconomics5',
      component: resolve => {
        require(['../view/emconomics/emconomics5.vue'], resolve)
      },
      meta:{
        title:'中国经济报告·Libra：数字货币的未来还是潘多拉魔盒？-巨丰财经&网易财经大型经济论坛，姚前，李扬，黄益平，黄卓，马骏，张承惠，王忠民，李礼辉，王永利，姜建清，余永定，彭文生，戴志锋，姚长盛等国内知名经济学家和顶级智囊受邀参会。',
        description: '2019年8月1日，由巨丰财经、清泉研究院主办，网易财经协办的大型经济论坛——“中国经济报告·Libra：数字货币的未来还是潘多拉魔盒？”将在北京钓鱼台国宾馆举行。姚前，李扬，黄益平，黄卓，马骏，张承惠，王忠民，李礼辉，王永利，姜建清，余永定，彭文生，戴志锋，姚长盛等数十名经济学家和顶级智囊将出席会议，共同探讨中国时下热点财经问题，把脉中国经济发展过程中的焦点、难点、痛点。',
        keywords: '巨丰投顾，中国经济报告，网易研究局，巨丰财经，网易财经，钓鱼台，研讨会，姚前，李扬，黄益平，黄卓，马骏，张承惠，王忠民，李礼辉，王永利，姜建清，余永定，彭文生，戴志锋，姚长盛，北京大学，清华大学，国务院发展研究中心，全国社会保障基金理事会，光大证券，中信证券，中泰证券'
      }
    },
    //进博会专题
    {
      path: '/credit-20191107',
      name: 'credit',
      component: resolve => {
        require(['../view/creditConstruction/credit.vue'], resolve)
      },
      meta:{
        title:'巨丰投顾协办第二届中国国际进口博览会中国信用建设论坛，宋志平、陈雨露、李稻葵、张新民、杨林兴、马琳、黎勇跃、李新友、吴晶妹、 许金华、马骏、周永强、周先标、李鸿双、刘冰、刘军、手嶋徹也等国内知名经济学家、政要和企业家受邀参会。',
        description: '2019年11月7日，由商务部指导、中国企业改革与发展研究会主办，巨丰投顾协办的“第二届中国国际进口博览会中国信用建设论坛”将在上海举行。陈雨露，李稻葵，张新民，杨林兴，马琳，黎勇跃，李新友，吴晶妹，许金华，马骏，周永强，周先标，李鸿双，刘冰，刘军，手嶋徹也等国内知名经济学家、政要和企业家受邀参会。本届中国信用建设论坛将以“信用的力量”为论坛主题，探讨“在推进新一轮高水平对外开放情况下，如何进一步更新和健全适应数字化时代要求的信用体系，让世界共享新时代中国的发展成果，共建全球包容、开放合作、互惠发展的发展环境”。',
        keywords: '巨丰投顾，第二届中国国际进口博览会中国信用建设论坛，中国信用建设论坛，信用的力量，上海国家会展中心，巨丰财经，网易财经，产经新闻，今日头条，中国企业改革与发展研究会，宋志平，陈雨露，李稻葵，张新民，杨林兴，马琳，黎勇跃，李新友，吴晶妹，许金华，马骏，周永强，周先标，李鸿双，刘冰，刘军，手嶋徹也'
      }
    },
    { // 财经观察家列表
      path: '/Observer/articleList',
      name: '/Observer/articleList',
      meta: {
        keepAlive: true,
        description: '财经观察家，是由清泉传媒与巨丰财经联手打造的高端财经日播视频。 财经观察家是高端经济学家的个人财经脱口秀，每期15分钟的日播节目。以财经评论员个人脱口秀的方式，对当天最值得关注的中国(国际)经济事件(现象)进行深度点评和解读。',
        keywords: '财经观察家,清泉传媒,巨丰财经,巨丰投顾,脱口秀,财经脱口秀,经济点评,事件点评,经济学家,财经评论员,中央电视台,央视,央视财经,叶檀,谭雅玲,左小蕾, 向松祚,田渭东,韩晓平,马光远'
      },
      component: resolve => {
        require(['../view/cjgcj_zhongxin/cjdk.vue'], resolve)
      }
    },
    { // 财经观察家列表
      path: '/Observer/articleDetail',
      name: 'articleDetail',
      meta: {
        description: '财经观察家，是由清泉传媒与巨丰财经联手打造的高端财经日播视频。 财经观察家是高端经济学家的个人财经脱口秀，每期15分钟的日播节目。以财经评论员个人脱口秀的方式，对当天最值得关注的中国(国际)经济事件(现象)进行深度点评和解读。',
        keywords: '财经观察家,清泉传媒,巨丰财经,巨丰投顾,脱口秀,财经脱口秀,经济点评,事件点评,经济学家,财经评论员,中央电视台,央视,央视财经,叶檀,谭雅玲,左小蕾, 向松祚,田渭东,韩晓平,马光远'
      },
      component: resolve => {
        require(['../view/cjgcj_zhongxin/cjdk-details.vue'], resolve)
      }
    },
    {//66元产品
      path:'/product',
      component:resolve=>{
        require(['../view/product/base.vue'],resolve)
      },
      children:product,
      meta:{
        title:'巨丰投顾'
      }
    },
    {//福州app隐私协议
      path:'/protocol',
        component: resolve=>{
         require(['../view/fuzhou_app/protocol.vue'],resolve)
      }
    },{ // 福州app诊股页面
      path:'/medicalStock',
        component: resolve=>{
        require(['../view/fuzhou_app/medicalStock.vue'],resolve)
      }
  },{  // 福州app诊股结果页面
      path:'/medicalGraph',
      component: resolve=>{
        require(['../view/fuzhou_app/medicalGraph.vue'],resolve)
      }
    },{ // 福州app免责声明
      path:'/disclaimer',
      component: resolve=>{
        require(['../view/fuzhou_app/disclaimer.vue'],resolve)
      }
    },{ // 公司介绍
      path:'/companyProfile',
      component: resolve=>{
        require(['../view/company/companyProfile.vue'],resolve)
      },
      meta: {
        title:'2018年巨丰感恩相伴：超越梦想 收获未来',
        description: '巨丰，感恩有你',
      },
    },{
      path:'/trader',
        component: resolve=>{
        require(['../view/trader/index.vue'],resolve)
      },
      meta: {
        description: "巨丰投顾2019年第二季操盘计划，抓住“改革牛”的历史机遇 · 砥砺前行。",
        keywords:"巨丰投顾，操盘计划，5G，基建，改革牛，军工，大科技，主题投资",
        title: "巨丰投顾-2019年第二季操盘计划-抓住“改革牛”的历史机遇 · 砥砺前行"
      },
    },
    { // 公司介绍
      path:'/studio',
      component: resolve=>{
        require(['../view/liveRoom/live.vue'],resolve)
      },
      meta: {
        title:'一股清泉演播厅',
        description: '一股清泉演播厅，h5',
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js